import { useEffect, useState } from "react";
import { Download, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { onInstallAvailabilityChange, promptInstall, isStandalone } from "@/lib/pwa";

export default function InstallPrompt() {
  const [available, setAvailable] = useState(false);
  const [dismissed, setDismissed] = useState(
    typeof window !== "undefined" && localStorage.getItem("es_install_dismissed") === "1",
  );

  useEffect(() => {
    if (isStandalone()) return;
    return onInstallAvailabilityChange(setAvailable);
  }, []);

  if (dismissed || !available) return null;

  const onInstall = async () => {
    await promptInstall();
    setAvailable(false);
  };

  const onDismiss = () => {
    setDismissed(true);
    localStorage.setItem("es_install_dismissed", "1");
  };

  return (
    <div className="fixed bottom-4 left-1/2 z-40 -translate-x-1/2 px-4 md:bottom-6" data-testid="install-prompt">
      <div className="glass flex items-center gap-3 rounded-full border border-border px-4 py-2.5 shadow-lg">
        <Download className="h-4 w-4 text-primary" />
        <span className="text-sm">Install Expense & Save for one-tap access</span>
        <Button size="sm" onClick={onInstall} className="rounded-full" data-testid="install-button">Install</Button>
        <Button size="icon" variant="ghost" onClick={onDismiss} aria-label="Dismiss">
          <X className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
}
